import React from "react";
import StepperHeader from "./StepperHeader";
import StepperContent from "./StepperContent";
import { Stack } from "@mui/material";

const steps = ["مشخصات", "مدارک", "تایید نهایی"];

export default function Stepper({
  state,
  refetch,
  activeStep,
  handleNext,
  handleBack,
  handleState,
}) {
  return (
    <Stack
      overflow="hidden"
      height="calc(100vh - 72px)"
      bgcolor="background.paper"
      justifyContent="space-between"
    >
      <StepperHeader steps={steps} activeStep={activeStep} />
      <StepperContent
        state={state}
        refetch={refetch}
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        handleState={handleState}
      />
    </Stack>
  );
}
